const originPath = window.location.origin;
const isProd = originPath === 'https://aop.com';
const localStorage = window.localStorage;

// ClassWallet variables
const _cwVar = 'classwallet:vars:json';
console.log(_cwVar);
const _cwCookie = 'classwallet_data';
const customerId = __st.cid?.toString() || '';

// SPT-388: student/parent Monarch launch-link behavior (teacher/get-driven
// when on). SPT-351: student data source (API vs metafield). Separate flags
// so each ticket can ship/cut over independently.
const ENABLE_SPT_388 = false;
const ENABLE_SPT_351 = true;

const _mfaHandles = [
  'monarch-all-access-yearly',
  'monarch-all-access-monthly',
  'monarch-addl-all-access-yearly',
  'monarch-addl-all-access-monthly'
];

const _messages = {
  singlepdp_mfa_student: "This course is included for your Full Access student. Assign this course by clicking Monarch Parent Access.",
  singlepdp_mfa_enroll_btn_text: "Monarch Parent Access",
  singlepdp_mfa_in_cart: "Single courses are included with Full Access subscriptions. To purchase single courses only, remove that student’s Monarch Full Access subscription from your cart or manage billing.",
  singlepdp_in_cart: "Course subscription already added to the cart for this student.",
  mfapdp_in_cart: "Subscription already added to the cart for this student.",
}

jQuery_T4NT(document).ready(function($) {
  /** ****************************Custom Page Start**********************************/
  var wishlistNumber = $('.t4s-account-nav-link--wishlist').length;
  if (wishlistNumber > 0) {
    setTimeout(function() {
      const countGet = $('#zooomy-wishlist-counter span').html();
      $('.t4s-account-nav-link--wishlist span').html(countGet);
    }, 1500);
  }
  $('.set > a').on('click', function() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).siblings('.content').slideUp(200);
      $('.set > a i').removeClass('fa-minus').addClass('fa-plus');
    } else {
      $('.set > a i').removeClass('fa-minus').addClass('fa-plus');
      $(this).find('i').removeClass('fa-plus').addClass('fa-minus');
      $('.set > a').removeClass('active');
      $(this).addClass('active');
      $('.content').slideUp(200);
      $(this).siblings('.content').slideDown(200);
    }
  });

  /** ****************************Custom Page End**********************************/
  const isNumericInput = (event) => {
    const key = event.keyCode;
    return ((key >= 48 && key <= 57) || // Allow number line
      (key >= 96 && key <= 105) // Allow number pad
    );
  };

  const isModifierKey = (event) => {
	  const key = event.keyCode;
	  return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
    (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
    (key > 36 && key < 41) || // Allow left, up, right, down
    (
      // Allow Ctrl/Command + A,C,V,X,Z
      (event.ctrlKey === true || event.metaKey === true) &&
      (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
    );
  };

  const enforceFormat = (event) => {
	  // Input must be of a valid number format or a modifier key, and not longer than ten digits
	  if (!isNumericInput(event) && !isModifierKey(event)) {
		  event.preventDefault();
	  }
  };

  const formatToPhone = (event) => {
	  if (isModifierKey(event)) { return; }

    const target = event.target;
    const input = target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
    const zip = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

  	if (input.length > 6) { target.value = `(${zip}) ${middle} - ${last}`; } else if (input.length > 3) { target.value = `(${zip}) ${middle}`; } else if (input.length > 0) { target.value = `(${zip}`; }
  };

  const inputElement = document.getElementById('AddressPhoneNew');
  if (inputElement) {
    inputElement.addEventListener('keydown', enforceFormat);
    inputElement.addEventListener('keyup', formatToPhone);
  }

  $(document).on('click', '.t4s-section-header .t4s-container nav.t4s-navigation li a', function(e) {
    if ($(this).siblings('.t4s-sub-menu').find('.t4s-lazy_menu')
      .children().length > 0) {
      e.preventDefault();
      $(this).parent('li').siblings('li')
        .removeClass('is-action__hover');
      $(this).parent('li').addClass('is-action__hover');
    }
  });

  // click outside
  $(document).mouseup(function(e) {
    var container = $('a.t4s-align-items-center');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(container).parent('li').removeClass('is-action__hover');
    }
  });

  // open poup click on header login/create account
  $('.t4s-top-bar-custom__html.t4s-rte--list .login, .login-btn').on('click', function() {
    $('.t4s-site-nav__icon.t4s-site-nav__account.t4s-pr.t4s-d-none.t4s-d-md-inline-block .t4s-pr').trigger('click');
  });


  // open poup click on header monarch access
  function resetHtmlDrawerStyles() {
  const html = document.documentElement;
  html.style.marginRight = "";
  html.style.removeProperty("--scroll-w");
}

(function () {
  let modal, closeButton, body, menuDrawer;

  function cacheModal() {
    modal = document.querySelector(".monarch-access-modal");
    closeButton = modal?.querySelector(".close-button");
    body = document.body;
    menuDrawer = document.getElementById("t4s-menu-drawer");
  }

  function removeOverlay() {
    const overlayVisible = document.querySelector(".t4s-close-overlay.is--visible");
    if (overlayVisible) {
      overlayVisible.classList.remove("is--visible");
      overlayVisible.style.display = "none";
    }
  }

  // Student Access: show exactly one link based on /apps/api/teacher/get's
  // classic value - "Monarch →" when false, "Monarch Classic →" when true.
  // On failure, don't guess which portal is correct - hide both and show a
  // retryable error instead of leaving the section silently empty. Shared
  // by openModal and the retry click handler below so the lookup isn't
  // duplicated.
  function updateStudentAccessLinks() {
    $('.student-access-error').hide();
    getTeacherInfo().then(function(teacherInfo) {
      const isClassic = teacherInfo.classic;
      $('.student-new-link').toggle(isClassic === false);
      $('.student-classic-link').toggle(isClassic === true);
    }).catch(function(err) {
      console.error('[monarch-access-modal] Unable to determine classic eligibility:', err);
      $('.student-new-link').hide();
      $('.student-classic-link').hide();
      $('.student-access-error').show();
    });
  }

  function openModal(e) {
    e?.preventDefault();
    e?.stopImmediatePropagation();

    cacheModal();
    if (!modal) return;

    modal.classList.add("show-modal");
    body.classList.remove("t4s-lock-scroll", "is--opend-drawer");

    if (menuDrawer) {
      menuDrawer.setAttribute("aria-hidden", "true");
    }

    removeOverlay();
    resetHtmlDrawerStyles();
    setTimeout(resetHtmlDrawerStyles, 50);

    if (ENABLE_SPT_388) {
      updateStudentAccessLinks();
    }
  }

  function closeModal() {
    if (!modal) return;

    modal.classList.remove("show-modal");
    body.classList.remove("t4s-lock-scroll", "is--opend-drawer");

    removeOverlay();
    resetHtmlDrawerStyles();
  }

  // 🔥 EVENT DELEGATION (KEY FIX)
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".monarch-access-link");
    if (!trigger) return;

    openModal(e);
  });

  // close button (delegated-safe)
  document.addEventListener("click", function (e) {
    if (e.target.closest(".monarch-access-modal .close-button")) {
      closeModal();
    }
  });

  // retry link in the Student Access error state (delegated-safe)
  document.addEventListener("click", function (e) {
    if (e.target.closest(".student-access-retry")) {
      e.preventDefault();
      updateStudentAccessLinks();
    }
  });

  window.addEventListener("click", function (e) {
    if (modal && e.target === modal) {
      closeModal();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeModal();
    }
  });
})();

  // login popup js
  var isALARenderedlogin;
  function ALAcheck_login() {
    isALARenderedlogin = setInterval(function() {
      customALA_login();
    }, 200);
  }
  ALAcheck_login();

  function customALA_login() {
    var selector = $('#login_login-sidebar');
    if (selector.length > 0) {
      clearInterval(isALARenderedlogin);

      $(document).find('#t4s-login-sidebar .t4s_field.t4s_mb_20 button').on('click', function(e) {
        var IDGet = $(this).parents('form').attr('id');
        if (IDGet == 'recover_customer_passwordlogin-sidebar') {
          e.preventDefault();
          $(this).parents('#recover_customer_passwordlogin-sidebar').submit();
        } else {
          var LoginRedirect = window.location.href;
          $('.loginFormPop').attr('value', LoginRedirect);
          var email = $('#CustomerEmail').val();
          var password = $(this).parents().siblings('.t4s_field.t4s-pr.t4s_mb_10').find('#CustomerPassword').val();
          if (!email) {
            e.preventDefault();
            $('.error_msg.email').text('This field is required');
          } else if (!password) {
            e.preventDefault();
            $('.error_msg.pass').text('This field is required');
          } else {
            var regEx = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            var validEmail = regEx.test(email);

            if (!validEmail) {
              e.preventDefault();
              $('.error_msg.email').text('Enter a valid email');
            } else if (password.length < 8) {
              e.preventDefault();
              $('.error_msg.pass').text('Password must be at least 8 characters long');
            } else {
              $('.error_msg.email').hide();
              $('.error_msg.pass').hide();
              $('.form-group.checkbox.t4s_mb_20 .h6').css('color', '#494d54');
              $(this).parents('#customer_loginlogin-sidebar').submit();
            }
          }
        }
      });

      $(document).find('#t4s-login-sidebar .t4s-drawer__content #login_login-sidebar #customer_loginlogin-sidebar .t4s_field .show-password').on('click', function() {
        var get_pass = $(this).parents('.t4s_field.t4s-pr.t4s_mb_10').find('#CustomerPassword').val();
        if ($($(this).parents('.t4s_field.t4s-pr.t4s_mb_10').find('#CustomerPassword')).attr('type') == 'password') {
          $(this).parents('.t4s_field.t4s-pr.t4s_mb_10').find('#CustomerPassword').attr('type', 'text');
          $(this).parents('.t4s_field.t4s-pr.t4s_mb_10').find('#CustomerPassword').val(get_pass);
          $('.active-state').show();
          $('.default-state').hide();
        } else {
          $(this).parents('.t4s_field.t4s-pr.t4s_mb_10').find('#CustomerPassword').attr('type', 'password');
          $('.active-state').hide();
          $('.default-state').show();
        }
      });
    }
  }

  // customALA register
  var isALARenderedreg;
  function ALAcheck_reg() {
    isALARenderedreg = setInterval(function() {
      customALA_reg();
    }, 200);
  }

  ALAcheck_reg();
  function customALA_reg() {
    var selector_1 = $('#create_login-sidebar');
    if (selector_1.length > 0) {
      clearInterval(isALARenderedreg);
      $(document).find('#customer_createlogin-sidebar .t4s_field.t4s-pr.t4s_mb_10 span.show-password').on('click', function() {
        var get_pass_retpe = $(this).siblings('input').val();
        if ($(this).siblings('input').attr('type') == 'password') {
          $(this).siblings('input').attr('type', 'text');
          $(this).siblings('input').val(get_pass_retpe);
          $(this).find('.active-state').show();
          $(this).find('.default-state').hide();
        } else {
          $(this).siblings('input').attr('type', 'password');
          $(this).find('.active-state').hide();
          $(this).find('.default-state').show();
        }
      });

      $(document).find('#t4s-login-sidebar .t4s_field.t4s_mb_20.register button').on('click', function(e) {
        var email = $('#RegisterForm-email').val();
        var password = $('#RegisterForm-password').val();
        var retype_password = $('#RegisterForm-RetypePassword').val();
        var first_name = $('#RegisterForm-FirstName').val();
        var last_name = $('#RegisterForm-LastName').val();
        var $this = $(this);
        var CurrentLink = window.location.href;
        CurrentLink = CurrentLink.split('?');
        CurrentLink = CurrentLink[0];
        $("#create_login-sidebar input[name='return_to']").val(CurrentLink);

        if (!first_name) {
          e.preventDefault();
          $('.fname_error').text('This field is required');
        } else if (!last_name) {
          e.preventDefault();
          $('.Lname_error').text('This field is required');
        } else if (!password) {
          e.preventDefault();
          $('.password-note-text').css('color', 'red');
        } else if (!retype_password) {
          e.preventDefault();
          $('.retype_pass').text('This field is required');
        } else if (!email) {
          e.preventDefault();
          $('.email_error').text('This field is required');
        } else {
          var regEx = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          var validEmail = regEx.test(email);
          if (!validEmail) {
            e.preventDefault();
            $('.error_msg.email').text('Enter a valid email');
          } else if (password.length < 8) {
            e.preventDefault();
            $('.password-note-text').css('color', 'red');
          } else if (password != retype_password) {
            e.preventDefault();
            $('.retype_pass').text('please add correct password');
          } else {
            $('.fname_error').hide();
            $('.Lname_error').hide();
            $('.password-note-text').css('color', '#1b1c1e');
            $('.retype_pass').hide();
            $('.email_error').hide();
            var encrypted = CryptoJS.AES.encrypt(password, 'password');
            localStorage.setItem('Fname', first_name);
            localStorage.setItem('Lname', last_name);
            localStorage.setItem('email', email);
            localStorage.setItem('pass', encrypted);
            localStorage.setItem('return_url', CurrentLink);
            $this.parents('#customer_createlogin-sidebar').submit();
          }
        }
      });
    }
  }
});

$('body').on('click', '.t4s-customer #create_customer .t4s_btn_submmit', function(e) {
  e.preventDefault();
  const formInput = {
    email: $('#RegisterForm-email').val(),
    password: $('#RegisterForm-password').val(),
    first_name: $('#RegisterForm-FirstName').val(),
    last_name: $('#RegisterForm-LastName').val()
  }
  const formErrors = {
    email: $('.email_error'),
    password: $('.password-note-text'),
    repass: $('.retype_pass'),
    first_name: $('.fname_error'),
    last_name: $('.Lname_error')
  }

  if (formInput.email && formInput.password && formInput.first_name && formInput.last_name) {
    var regEx = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var validEmail = regEx.test(formInput.email);
    if (!validEmail) {
      e.preventDefault();
      $('.error_msg.email').text('Enter a valid email');
    } else if (formInput.password.length < 8) {
      e.preventDefault();
      formErrors.password.css('color', 'red');
    } else {
      formErrors.first_name.hide();
      formErrors.last_name.hide();
      formErrors.password.css('color', '#1b1c1e');
      formErrors.repass.hide();
      formErrors.email.hide();

      var encrypted = CryptoJS.AES.encrypt(formInput.password, 'password');
      localStorage.setItem('Fname', formInput.first_name);
      localStorage.setItem('Lname', formInput.last_name);
      localStorage.setItem('email', formInput.email);
      localStorage.setItem('pass', encrypted);
      $('#create_customer').submit();
    }
  } else {
    if (!formInput.first_name) {
      e.preventDefault();
      formErrors.first_name.text('This field is required');
    }

    if (!formInput.last_name) {
      e.preventDefault();
      formErrors.last_name.text('This field is required');
    }

    if (!formInput.password) {
      e.preventDefault();
      formErrors.password.css('color', 'red');
    }

    if (!formInput.email) {
      e.preventDefault();
      formErrors.email.text('This field is required');
    }
  }
});

var errorlngth = ($('.form__message').length);
var pasencrypted = (localStorage.getItem('pass'));
var emailGet = (localStorage.getItem('email'));
var firstName = (localStorage.getItem('Fname'));
var lastName = (localStorage.getItem('Lname'));
var pathname = window.location.pathname;

if (localStorage.getItem("pass") !== null) {
  if ((errorlngth == 1) && (pathname=="/account/register")) {
    localStorage.removeItem('return_url');
  } else {
    if (localStorage.getItem("return_url") !== null) {
      const CurrentPath = $(location).attr("pathname");
      if ((CurrentPath !== "/challenge")) {
        $('body').addClass('site-loader-active');
        if (CurrentPath.indexOf("account/register") != -1) {
          if (errorlngth > 0) {
            localStorage.removeItem('return_url');
            $('body').removeClass('site-loader-active');
          } else {
            $('body').removeClass('site-loader-active');
            var locationget = (localStorage.getItem("return_url"));
            window.location.href = locationget;
            localStorage.removeItem('return_url');
          }
        } else {
          var decrypted = CryptoJS.AES.decrypt(pasencrypted, "password");
          decrypted = decrypted.toString(CryptoJS.enc.Utf8);
          ajaxUrl = originPath+'/apps/api/teacher/save';
          var data = new FormData();
          data.append('first_name', firstName);
          data.append('last_name', lastName);
          data.append('password', decrypted);
          data.append('email', emailGet);

          function reqListener() {
            var getstatus = this.responseText;
            getstatus = $.parseJSON(getstatus); //convert to javascript array
            var geterrortext = "";

            $.each(getstatus,function(key,value) {
              if (key == "error") {
                var locationget = (localStorage.getItem("return_url"));
                geterrortext = value;
                localStorage.clear();
                localStorage.setItem('logout_url', locationget);
                localStorage.setItem('logout_message', geterrortext);
                window.location.href = locationget;
                $('body').removeClass('site-loader-active');
              } else if(key == "success") {
                var locationget = (localStorage.getItem("return_url"));
                window.location.href = locationget;
                localStorage.removeItem('return_url');
                localStorage.clear();
                $('body').removeClass('site-loader-active');
              }
            });
          }

          const req = new XMLHttpRequest();
          req.addEventListener("load", reqListener);
          req.open("POST", ajaxUrl);
          req.send(data);
        }
      }
    } else {
      const CurrentPath = $(location).attr("pathname");
      if ((CurrentPath !== "/challenge")) {
        $('body').addClass('site-loader-active');
        var decrypted = CryptoJS.AES.decrypt(pasencrypted, "password");
        decrypted = decrypted.toString(CryptoJS.enc.Utf8);
        ajaxUrl = originPath+'/apps/api/teacher/save';

        var data = new FormData();
        data.append('first_name', firstName);
        data.append('last_name', lastName);
        data.append('password', decrypted);
        data.append('email', emailGet);

        function reqListener() {
          var getstatus = this.responseText;
          getstatus = $.parseJSON(getstatus); //convert to javascript array
          var geterrortext = "";
          $.each(getstatus,function(key,value){
            if (key == "error") {
              var locationget = window.location.href;
              geterrortext = value;
              localStorage.clear();
              localStorage.setItem('logout_url', locationget);
              localStorage.setItem('logout_message', geterrortext);
              window.location.href = locationget;
              $('body').removeClass('site-loader-active');
            } else if (key == "success") {
              $('body').removeClass('site-loader-active');
              localStorage.clear();
            }
          });
        }

        const req = new XMLHttpRequest();
        req.addEventListener("load", reqListener);
        req.open("POST", ajaxUrl);
        req.send(data);
      }
    }
  }
}

if (localStorage.getItem("logout_url") !== null) {
  const CurrentPath = $(location).attr("pathname");
  if ((CurrentPath !== "/challenge")) {
    if (!(CurrentPath.indexOf("account/register") != -1)) {
      setTimeout(function() {
        let targetElement = document.querySelector(".t4s-top-bar__html ul li.login");
        targetElement.querySelector("a").click();

        var locationget = (localStorage.getItem("logout_message"));
        var html = '<p style="color:red;">'+locationget+'</p>';
        var target_msg = document.querySelector('.t4s-drawer__header .is--create');

        if (target_msg) {
          target_msg.insertAdjacentHTML('beforeend', html);
        } else {
          console.error('Target element not found');
        }

        document.querySelector('.t4s-drawer__header .is--login').setAttribute('aria-hidden','true');
        document.querySelector('.t4s-drawer__header .is--create').setAttribute('aria-hidden','false');
        document.querySelector('.t4s-drawer__main #login_login-sidebar').setAttribute('aria-hidden','true');
        document.querySelector('.t4s-drawer__main #create_login-sidebar').setAttribute('aria-hidden','false');

        localStorage.removeItem('logout_url');
        localStorage.removeItem('logout_message');
      }, 1500);
    }
  }
}

$(window).scroll(function() {
  var sticky = $('.t4s-section-header');
  var scroll = $(window).scrollTop();
  scroll >= 100
  ? (sticky.addClass('site-header--stuck'),
    setTimeout(function() {
      sticky.addClass('site-header--opening');
    }, 100))
  : (sticky.removeClass('site-header--stuck'),
    setTimeout(function() {
      sticky.removeClass('site-header--opening');
    }, 100));
});

$('.t4s-close-overlay, .t4s-drawer__close, .done-text').click(function(e) {
  e.preventDefault();
  if ($(this).hasClass('student_cancel')) {
    location.reload();
  } else {
    $('.t4s-close-overlay').removeClass('is--visible open');
    $('#t4s-consest-modal').removeClass('open');
    $('body').removeClass('show-popup');
    $('html').removeClass('show-popup');
  }
});

$('.dropdown.student-meta.digital-drop .select').click(function() {
  $(this).next('ul').toggle();
  $(this).toggleClass('open');
});

setTimeout(function() {
  $('.t4s-countdown-pr.t4s-text-start.t4s-dn.t4s-countdown-enabled').show();
}, 3000);

/** *****************************Mobile Login Start *************************************/
$('body').on('click', '.mobile-login a', function(e) {
  e.preventDefault();
  $('#t4s-menu-drawer').attr('aria-hidden', 'true');
  $('#t4s-login-sidebar').attr('aria-hidden', 'false');
  $('body').addClass('t4s-lock-scroll is--opend-drawer');
  $('.t4s-close-overlay.t4s-op-0').addClass('is--visible');
});

/** *****************************Mobile Register End**************************************/
/** *********************************************Enroll Popup Start*****************************************/

$('.confirm-enroll-btn, .enroll_close').click(function() {
  $('.enroll-confirmation-overlay').removeClass('is--visible');
  $('.enroll-conformation-popup').attr('aria-hidden', 'true');
  var studentId = $('.old-enrl-free-btn').attr('data-studentId');
  var handle = $('.old-enrl-free-btn').attr('data-prohandle');
  var combined = (studentId + handle);
  localStorage.removeItem(combined);
  location.reload();
});

/** *********************************************Enroll Popup End*****************************************/
/** *********************************************MAIN Image Loading Issue on PDP START*****************************************/
setTimeout(function() {
  $('.t4s-product__media-wrapper.visiblityHide').removeClass('visiblityHide');
  $('.t4s-col-item.t4s-product__info-wrapper.t4s-pr.VisiblityInfo').removeClass('VisiblityInfo');
}, 3000);

/** *********************************************MAIN Image Loading Issue on PDP END*****************************************/
/** *********************************************Monarch Link START*****************************************/

// Cached in sessionStorage so it survives page navigation but not the
// browser session - sessionStorage is cleared automatically when the tab/
// session ends. Logout (below) also removes it explicitly, but not every
// logout path goes through that handler (e.g. layout/theme.liquid redirects
// straight to /account/logout in some cases), so the key is also scoped by
// customerId - a different customer signing in in the same tab gets a cache
// miss instead of reusing a stale cross-account entry. teacherGetPromise
// only de-dupes concurrent calls within the current page. Defined
// unconditionally (it does nothing until called) so both the new and old
// branches below can share it without duplicating this machinery.
const _teacherGetCacheKey = `teacherGetInfo:${customerId}`;
let teacherGetPromise = null;
// Rejects (rather than resolving classic=false) on a transport error, a bad
// status, or a response missing "classic" - a real API failure must not be
// silently treated as "not classic-eligible", since that could launch a
// classic-eligible account into the wrong portal. Callers must handle the
// rejection explicitly. Failures also reset teacherGetPromise so the next
// call retries instead of being stuck on a cached failure.
function getTeacherInfo() {
  if (!teacherGetPromise) {
    var cached = sessionStorage.getItem(_teacherGetCacheKey);
    if (cached !== null) {
      teacherGetPromise = Promise.resolve(JSON.parse(cached));
    } else {
      teacherGetPromise = new Promise(function(resolve, reject) {
        function reqListener() {
          if (this.status < 200 || this.status >= 300) {
            reject(new Error('teacher/get failed with status ' + this.status));
            return;
          }
          var result;
          try {
            result = $.parseJSON(this.responseText);
          } catch (err) {
            reject(err);
            return;
          }
          if (!result || typeof result.classic === 'undefined') {
            reject(new Error('teacher/get response missing classic'));
            return;
          }
          sessionStorage.setItem(_teacherGetCacheKey, JSON.stringify(result));
          resolve(result);
        }

        const req = new XMLHttpRequest();
        req.addEventListener('load', reqListener);
        req.addEventListener('error', function() {
          reject(new Error('teacher/get network error'));
        });
        req.open('GET', `${originPath}/apps/api/teacher/get`);
        req.setRequestHeader('ngrok-skip-browser-warning', '69420');
        req.send();
      }).catch(function(err) {
        teacherGetPromise = null;
        throw err;
      });
    }
  }
  return teacherGetPromise;
}

// Kick off the fetch as soon as the session initializes, instead of waiting
// for the Monarch Access click - by the time the modal opens or a link is
// clicked, the (cached) result is already available, removing the delay.
if (ENABLE_SPT_388 && customerId) {
  getTeacherInfo().catch(function(err) {
    console.error('[teacher/get] prefetch failed, will retry on next use:', err);
  });
}

// SPT-351: mirrors getTeacherInfo's caching strategy exactly, for
// /apps/api/student/get - same sessionStorage cache (scoped by customerId
// for the same cross-account reason as _teacherGetCacheKey above), same
// in-flight promise de-dupe, same fail-loud-not-silently-wrong contract (a
// real API failure rejects rather than resolving to an empty/guessed
// student list). Defined unconditionally (inert until called) so both the
// new and old student-data paths can share this machinery without
// duplicating it - same reasoning as getTeacherInfo above.
const _studentGetCacheKey = `studentGetInfo:${customerId}`;
let studentGetPromise = null;

function _requestStudentList() {
  return new Promise(function(resolve, reject) {
    function reqListener() {
      if (this.status < 200 || this.status >= 300) {
        reject(new Error('student/get failed with status ' + this.status));
        return;
      }
      var result;
      try {
        result = $.parseJSON(this.responseText);
      } catch (err) {
        reject(err);
        return;
      }
      if (!result || !Array.isArray(result.students)) {
        reject(new Error('student/get response missing students'));
        return;
      }
      resolve(result);
    }

    const req = new XMLHttpRequest();
    req.addEventListener('load', reqListener);
    req.addEventListener('error', function() {
      reject(new Error('student/get network error'));
    });
    req.open('GET', `${originPath}/apps/api/student/get`);
    req.setRequestHeader('ngrok-skip-browser-warning', '69420');
    req.send();
  });
}

function getStudentInfo() {
  if (!studentGetPromise) {
    var cached = sessionStorage.getItem(_studentGetCacheKey);
    if (cached !== null) {
      studentGetPromise = Promise.resolve(JSON.parse(cached));
    } else {
      studentGetPromise = _requestStudentList().then(function(result) {
        sessionStorage.setItem(_studentGetCacheKey, JSON.stringify(result));
        return result;
      }).catch(function(err) {
        studentGetPromise = null;
        throw err;
      });
    }
  }
  return studentGetPromise;
}

// Always live - bypasses both the in-flight de-dupe and the sessionStorage
// cache, and never writes either. Used only by the SPT-425 anti-leak
// checkout guard (digital-ordergroove.js.liquid), which must validate the
// selected student against current data, not anything cached for this tab.
function getStudentInfoFresh() {
  return _requestStudentList();
}

// Maps one /apps/api/student/get student onto the field names already used
// throughout the theme for customer.metafields.custom.student_accounts
// entries. package_subscription/package_subscription_active/
// package_subscription_expiration are intentionally NOT mapped here - the
// API doesn't provide them; callers that need them look up a matching
// metafield entry by student_id themselves (SPT-351).
function mapApiStudent(apiStudent) {
  return {
    student_id: apiStudent.shopifyId,
    first_name: apiStudent.firstName,
    last_name: apiStudent.lastName,
    username: apiStudent.username,
    active: apiStudent.active,
    classic: apiStudent.classic
  };
}

// Gated the same way as the teacher/get prefetch above: only for a
// logged-in customer, and only when the flag is on - guests and flag-off
// sessions never call this, so guest behavior can't depend on the flag.
if (ENABLE_SPT_351 && customerId) {
  getStudentInfo().catch(function(err) {
    console.error('[student/get] prefetch failed, will retry on next use:', err);
  });
}

$(document).on('click', '.monarch_link', function(e) {
  e.preventDefault();
  $('.monarch_link').addClass('monarch_api');
  logoutURL = `${originPath}/account/logout/`;

  if (ENABLE_SPT_388) {
    const $link = $(this);

    getTeacherInfo().then(function(teacherInfo) {
      const isClassic = teacherInfo.classic;
      // data-classic no longer comes from the liquid markup - it's set here
      // from the live /apps/api/teacher/get result so the DOM reflects what
      // was used.
      $link.attr('data-classic', isClassic);
      ajaxUrl = `${originPath}/apps/api/lms/launches?classic=${isClassic}`;

      function reqListener() {
        var getstatus = this.responseText;
        getstatus = $.parseJSON(getstatus); // convert to javascript array
        $.each(getstatus, function(_key, value) {
          if ((value === null)) {
            $('.monarch_link.monarch_api').removeClass('monarch_api');
          } else if (value == false) {
            window.location.href = isProd ? 'https://monarch-app.aop.com/': "https://consumer-lms.cns-staging-shard-monarch.il-consumer.com/";
            $('.monarch_link.monarch_api').removeClass('monarch_api');
          } else {
            window.location.href = value;
            $('.monarch_link.monarch_api').removeClass('monarch_api');
          }
        });
      }

      const req = new XMLHttpRequest();
      req.addEventListener('load', reqListener);
      req.open('POST', ajaxUrl);
      req.setRequestHeader('ngrok-skip-browser-warning', '69420');
      req.send();

      // Clear account-specific data before the background logout/navigation -
      // $.ajax(logoutURL) does not go through the a[href='/account/logout']
      // click handler below, so this cache must be cleared here too.
      teacherGetPromise = null;
      sessionStorage.removeItem(_teacherGetCacheKey);
      studentGetPromise = null;
      sessionStorage.removeItem(_studentGetCacheKey);
      $.ajax(logoutURL);
    }).catch(function(err) {
      console.error('[monarch_link] Unable to determine classic eligibility, aborting launch:', err);
      $('.monarch_link.monarch_api').removeClass('monarch_api');
    });
  } else {
    let isClassic = $(this).data('classic');
    isClassic = (typeof isClassic === 'undefined') ? true : isClassic;
    ajaxUrl = `${originPath}/apps/api/lms/launches?classic=${isClassic}`;

    function reqListener() {
      var getstatus = this.responseText;
      getstatus = $.parseJSON(getstatus); // convert to javascript array
      $.each(getstatus, function(_key, value) {
        if ((value === null)) {
          $('.monarch_link.monarch_api').removeClass('monarch_api');
        } else if (value == false) {
          window.location.href = isProd ? 'https://monarch-app.aop.com/': "https://consumer-lms.cns-staging-shard-monarch.il-consumer.com/";
          $('.monarch_link.monarch_api').removeClass('monarch_api');
        } else {
          window.location.href = value;
          $('.monarch_link.monarch_api').removeClass('monarch_api');
        }
      });
    }

    const req = new XMLHttpRequest();
    req.addEventListener('load', reqListener);
    req.open('POST', ajaxUrl);
    req.setRequestHeader('ngrok-skip-browser-warning', '69420');
    req.send();

    // logout
    $.ajax(logoutURL)
      .done(function() {
        console.log('done');
      });
  }
});

/** *********************************************Monarch Link END *****************************************/
/** *************************************On Logout Button click Start **********************************/
// Cart clearing on logout is handled by the sitewide guest/grantee check in
// layout/theme.liquid, which removes only grantee-tied (__og_grantees) line
// items rather than the whole cart (SPT-425). Wiping the entire cart here
// unconditionally would undo that selective behavior.
$("a[href='/account/logout']").click(function(e) {
  localStorage.clear();
  teacherGetPromise = null;
  sessionStorage.removeItem(_teacherGetCacheKey);
  studentGetPromise = null;
  sessionStorage.removeItem(_studentGetCacheKey);

  // Clear Classwallet data
  document.cookie = `${_cwCookie}=; Max-Age=-99999999;`;
  sessionStorage.removeItem(`${_cwVar}`);
});

/** *********************************************Student Popup Start *****************************************/
$('.provide-consent-form .provide_consent').click(function(e) {
  e.preventDefault();
  $('.new-student-detail-form').show();
  $('.provide-consent-form').hide();
});

$('.student-subcription-item').click(function(_e) {
  const getPrice = $(this).attr('data-price');
  const getTitle = $(this).attr('data-tit');
  const getHandle = $(this).attr('data-handle');
  const offPercentage = $(this).attr('data-off');
  const getCompare = $(this).attr('data-compare');
  const variantIdGet = $(this).attr('data-id');
  const sellingId = $(this).attr('data-selling');
  const priceDiv = $('.t4s-main-product__content .t4s-product__info-container .t4s-product-price del');
  const priceBadgeDiv = $('.t4s-main-product__content .t4s-product__info-container span.t4s-badge-price')

  // On Full Access PDP, construct title from theme settings + cadence instead of raw variant title
  let displayTitle = getTitle;
  const isMfaPdp = $('.full-access-purchase').length > 0;
  if (isMfaPdp) {
    // Use the globally stored trial eligibility from the selected student
    const trialEligible = typeof window.currentStudentTrialEligible !== 'undefined' ? window.currentStudentTrialEligible : false;
    const getProductName = $(this).attr('data-name') || '';
    const isYearly = getProductName.toLowerCase().includes('yearly');
    const cadenceLabel = isYearly ? 'Yearly' : 'Monthly';
    if (trialEligible) {
      displayTitle = "Full Access 30-Day Free Trial" + ' ' + cadenceLabel;
    } else {
      displayTitle = "Full Access" + ' ' + cadenceLabel + ' Subscription';
    }
  }
  $('.t4s-product__title').html(displayTitle);
  $('.t4s-product__info-container .t4s-product-price').html(getPrice);

  if (typeof offPercentage !== 'undefined' && offPercentage !== false) {
    priceDiv.html(getCompare);
    priceBadgeDiv.html(offPercentage + 'Off');

    priceDiv.show();
    priceBadgeDiv.show();
  } else {
    priceDiv.hide();
    priceBadgeDiv.hide();
  }

  $("input[name='selling_plan']").val(sellingId);

  if ($('select.t4s-product__select').length > 0) {
    $('select.t4s-product__select option').val(variantIdGet);
  } else {
    $(".t4s-form__product input[name='id']").val(variantIdGet);
  }
  $(this).siblings(".student-subcription-item").removeClass("active");
  $(this).addClass("active");

  const studentname = $(".purchasing-block ul .rest-listing.active").attr('data-name');
  const is_mfa_pdp = _mfaHandles.indexOf(getHandle) > -1;

  $.ajax({
    url: '/cart.js',
    type: 'GET',
    dataType: 'json',
    success: function(cart){
      data = (cart['items']);
      const all_pdp_options = document.querySelectorAll('.student-subcription-item');

      // Read all cart items
      $.each(data, function(_i, item) {
        const cart_item_id = item.id; // id of cart item
        const cart_student_name = item.properties["Student Name"]; // student on cart item
        const cart_item_is_mfa = _mfaHandles.indexOf(item.handle) > -1;

        // Read all cart items
        setTimeout(function() {
          if (cart_student_name == studentname) {
            // Test 1 - Is the cart item a variant of current PDP?
            let variant_in_cart = false;

            $.each(all_pdp_options, function (_n, opt) {
              const subs_item = opt.getAttribute('data-id');

              // if cart contains any of the pdp variants, flag
              if(cart_item_id == subs_item){
                variant_in_cart = true;
              }
            });

            if (variant_in_cart) { // one of the pdp variants in cart - show message
              setTimeout(function() {
                // show message based on pdp type
                if (is_mfa_pdp) {
                  $(".access-text").html(_messages.mfapdp_in_cart).show();
                } else {
                  $(".access-text").html(_messages.singlepdp_in_cart).show();
                }

                $(".custom-btns .t4s-product-form__submit").attr('disabled','disabled');
              }, 10);
            } else {
              if (cart_item_is_mfa) {
                // Test 2 - Is the cart item full access?
                $(".access-text").html(_messages.singlepdp_mfa_in_cart).show();
                setTimeout(function() {
                  $(".custom-btns .t4s-product-form__submit").attr('disabled','disabled');
                }, 150);
              } else {
                $(".custom-btns .t4s-product-form__submit").removeAttr('disabled');
                $(".access-text").hide();
              }
            }
          } else {
            $(".custom-btns .t4s-product-form__submit").removeAttr('disabled');
            $(".access-text").hide();
          }
        }, 200);
      })
    },
    error: function(status){}
  });
})

$('body').on('click', '.addstudent', function(e) {

  e.preventDefault();
  $('body').addClass('show-popup');
  $('html').addClass('show-popup');
  $('.t4s-close-overlay.student_cancel').addClass('is--visible open');
  $('#t4s-consest-modal').addClass('open');
});

/** *********************************************Student Popup End *****************************************/
$('.variant_drop').on('change', function() {
  const variantId = $('option:selected', this).attr('data-id');
  const sellingId = $('option:selected', this).attr('seling-id');

  $(this).prev('.student_name').prev('input').val(variantId);
  $(this).parents('.product_form').children('.selling_plan').val(sellingId);
});

/** ***************************************BLOG JS START*************************************/
$('.dropdown.mobile-category-drodown .select.customCat').click(function() {
  $(this).next('input').next('.t4s-blog-categories').toggleClass('open');
});

$('.dropdown.mobile-category-drodown .select.customTags').click(function() {
  $(this).next('input').next('.t4s-blog-tags').toggleClass('open');
});

/** ***************************************STUDENT ADD JS START*************************************/
$('.AddStudentCustom').click(function(e) {
  var user = $('#username').val();
  var password = $('#CustomerPassword').val();
  var retype_password = $('#CustomerRecoverPassword').val();
  var first_name = $('#firstname').val();
  var last_name = $('#lastname').val();

  if (!first_name) {
    e.preventDefault();
    $('#firstname').css('border-color', 'red');
    $('#lastname').css('border-color', '#707070');
    $('#username').css('border-color', '#707070');
    $('#CustomerRecoverPassword').css('border-color', '#707070');
    $('#CustomerPassword').css('border-color', '#707070');
    $('.password-note-text').css('color', '#1b1cle');
  } else if (!last_name) {
    e.preventDefault();
    $('#lastname').css('border-color', 'red');
    $('#firstname').css('border-color', '#707070');
    $('#username').css('border-color', '#707070');
    $('#CustomerRecoverPassword').css('border-color', '#707070');
    $('#CustomerPassword').css('border-color', '#707070');
    $('.password-note-text').css('color', '#1b1cle');
  } else if (!user) {
    e.preventDefault();
    $('#username').css('border-color', 'red');
    $('#firstname').css('border-color', '#707070');
    $('#lastname').css('border-color', '#707070');
    $('#CustomerRecoverPassword').css('border-color', '#707070');
    $('#CustomerPassword').css('border-color', '#707070');
    $('.password-note-text').css('color', '#1b1cle');
  } else if (!password) {
    e.preventDefault();
    $('#password-note-text').css('color', 'red');
    $('#firstname').css('border-color', '#707070');
    $('#lastname').css('border-color', '#707070');
    $('#username').css('border-color', '#707070');
    $('#CustomerRecoverPassword').css('border-color', '#707070');
    $('.password-note-text').css('color', '#1b1cle');
  } else if (!retype_password) {
    e.preventDefault();
    $('#CustomerRecoverPassword').css('border-color', 'red');
    $('#firstname').css('border-color', '#707070');
    $('#lastname').css('border-color', '#707070');
    $('#username').css('border-color', '#707070');
    $('#CustomerPassword').css('border-color', '#707070');
    $('.password-note-text').css('color', '#1b1cle');
  } else {
    e.preventDefault();
    if (password.length < 8) {
      e.preventDefault();
      $('.password-note-text').css('color', 'red');
    } else if (password != retype_password) {
      e.preventDefault();
      $('.error_msg.pass').text('please add correct password');
    } else {
      $(this).addClass('loaderActive');
      $('#firstname').css('border-color', '#707070');
      $('.password-note-text').css('color', '#1b1cle');
      $('#lastname').css('border-color', '#707070');
      $('#username').css('border-color', '#707070');
      $('#CustomerRecoverPassword').css('border-color', '#707070');
      $('#CustomerPassword').css('border-color', '#707070');
      $('.error_msg.pass').text(' ');

      ajaxUrl = `${originPath}/apps/api/student/save`;
      var data = new FormData();
      data.append('first_name', first_name);
      data.append('last_name', last_name);
      data.append('password', password);
      data.append('username', user);
      data.append('coppa_consent', 'true');
      data.append('student_id', crypto.randomUUID());
      data.append('package_subscription', 'false');
      data.append('package_subscription_active', 'false');
      data.append('package_subscription_expiration', ' ');
      data.append('package_subscription_calculated_expiration', ' ');
      data.append('fullprice', 'false');
      data.append('created_on', ' ');
      data.append('updated_on', ' ');

      function reqListener() {
        var getstatus = $.parseJSON(this.responseText); // convert to javascript array
        var geterrortext = '';
        $.each(getstatus, function(key, value) {
          if (key == 'error') {
            geterrortext = value;
            value = value.split(':');
            value = value[1];
            if (geterrortext.indexOf('student was already created') != -1 || geterrortext.indexOf('Student with such username already exists') != -1) {
              $('.student_error').html('Username already exists. Add a number series to make it unique (e.g., User789). Special characters are not allowed.');
            } else {
              $('.student_error').html('Error adding the student, please try again.');
            }
            $('.AddStudentCustom').removeClass('loaderActive');
          } else if (key == 'success') {
	    function myCallback() {
              	var item = {
               	"StudentFirstname": first_name,
               	"StudentLastName": last_name,
               	"StudentUserName": user
              	};
              	klaviyo.track("Add Student", item);
            }
            klaviyo.identify({
              'email' : customerEmail,
              '$first_name' : customerFirstName,
              '$last_name' : customerLastName
            }, myCallback);
            $('#Addstudentform')[0].reset();
            $('.new-student-detail-form').hide();
            $('.student-added-form-detail').show();
            $('.student_error').html(' ');
            $('.AddStudentCustom').removeClass('loaderActive');

            if (ENABLE_SPT_351) {
              // SPT-351: force a fresh /apps/api/student/get so the new
              // student shows up next time the list is read, instead of
              // serving the pre-add cached response for the rest of the
              // tab's session.
              studentGetPromise = null;
              sessionStorage.removeItem(_studentGetCacheKey);
              getStudentInfo().catch(function(err) {
                console.error('[student/get] refresh after add failed:', err);
              });
            }
          }
        });
      }

      const req = new XMLHttpRequest();
      req.addEventListener('load', reqListener);
      req.open('POST', ajaxUrl);
      req.setRequestHeader('ngrok-skip-browser-warning', '69420');
      req.send(data);
    }
  }
});

$('.show-password').click(function() {
  if ($(this).prev('label').prev('input').attr('type') === 'password') {
    $(this).prev('label').prev('input').attr('type', 'text');
  } else {
    $(this).prev('label').prev('input').attr('type', 'password');
  }
});
/** ***************************************STUDENT ADD JS END*************************************/

/** ***************************************CART JS START*************************************/
$('body').on('click', '.checkfullPrice , .minus_custom_quant', function(e) {
  e.preventDefault();
  var getKeyCurrent = $(this).attr('href');

  $('.confirm-command-btn').attr('data-path', getKeyCurrent);
  $.ajax({
    url: '/cart.js',
    type: 'GET',
    dataType: 'json',
    success: function(cart) {
      data = (cart.items);
      var arrayGet = [];
      $.each(data, function(_i, item) {
        arrayGet.push(item.title);
      });
      if ((arrayGet.includes('Additional Student Full Access Subscription Yearly - Yearly Free Trial')) || (arrayGet.includes('Additional Student Full Access Subscription Monthly - Monthly Free Trial')) || (arrayGet.includes('Additional Student Full Access Subscription Monthly - Monthly')) || (arrayGet.includes('Additional Student Full Access Subscription Yearly - Yearly'))) {
        $('.cart-confirmation-overlay').addClass('is--visible');
        $('.cart-conformation-popup').attr('aria-hidden', 'false');
      } else {
        $.ajax({
          type: 'POST',
          url: getKeyCurrent,
          data: '',
          dataType: 'json',
          success: function(_data) {
            location.reload();
          },
        });
      }
    },
  });
});

$('body').on('click', '.confirm-command-btn', function(e) {
  e.preventDefault();
  var getKeyCurrent = $(this).attr('data-path');
  $.ajax({
    url: '/cart.js',
    type: 'GET',
    dataType: 'json',
    success: function(cart) {
      data = (cart.items);
      $.each(data, function(_i, item) {
        var getTitle = (item.title);
        var getKey = (item.key);
        if ((getTitle == 'Additional Student Full Access Subscription Yearly - Yearly Free Trial') || (getTitle == 'Additional Student Full Access Subscription Monthly - Monthly Free Trial') || (getTitle == 'Additional Student Full Access Subscription Monthly - Monthly') || (getTitle == 'Additional Student Full Access Subscription Yearly - Yearly')) {
          $.ajax({
            type: 'POST',
            url: `${originPath}/cart/change?quantity=0&id=${getKey}`,
            data: '',
            dataType: 'json',
            success: function(_data) {
              $.ajax({
                type: 'POST',
                url: originPath + getKeyCurrent,
                data: '',
                dataType: 'json',
                success: function(_data) {
                  location.reload();
                },
              });
            },
          });
        }
      });
    },
  });
});

$('body').on('click', '.cancel-comman-btn, .cart-confirmation-overlay', function(e) {
  e.preventDefault();
  $('.t4s-close-overlay.t4s-op-0.cart-confirmation-overlay').removeClass('is--visible');
  $('.cart-conformation-popup').attr('aria-hidden', 'true');
});

/** ***************************************CART JS END*************************************/
/** ***************************** Cookie Helpers *************************************/
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function setCookieshort(name, value, hours) {
  var expires = "";
  if (hours) {
    var date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000)); // Convert hours to milliseconds
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

/** ***************************** End Cookie Helpers *************************************/

function base64Decode(str) {
  return decodeURIComponent(atob(str).split('').map(function(c) {
   return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
 }).join(''));
}

function isValidCustomer(token) {
  console.log('confirm customer...');
 const decryptedToken = JSON.parse(base64Decode(token));
  console.log(decryptedToken);
  console.log("customerID: ", customerId)
 return decryptedToken?.shopify_customer_id == customerId;
}

// cart page digital/classwallet check
document.addEventListener('DOMContentLoaded', function() {
  //on load check cookie and session
  const classwallet_sessionData_load = sessionStorage.getItem(`${_cwVar}`);
  var myCookie = getCookie(`${_cwCookie}`);

  if (!!classwallet_sessionData_load && !myCookie) {
    console.log("session, no cookie")
    if (isValidCustomer(classwallet_sessionData_load)) {
      setCookieshort(`${_cwCookie}`, classwallet_sessionData_load, 1);
    }
  } else if (!!myCookie && !classwallet_sessionData_load) {
    console.log("cookie, no session")
    sessionStorage.setItem(`${_cwVar}`, myCookie);
  }

  if (document.body.classList.contains('template-cart')) {
    console.log("is cart page");
    function check_classwallet(){
      const checkout_btn = document.querySelector('.t4s-btn__checkout');

      if (checkout_btn) {
        checkout_btn.style.display = 'block';
      }


      /** ****************************ClassWallet - Updated Start**********************************/
      const classwallet_sessionData = sessionStorage.getItem(`${_cwVar}`);
      const error_msg = document.querySelector('.checkout_above_msg');

      if (classwallet_sessionData) {
        const decodedCwToken = JSON.parse(base64Decode(classwallet_sessionData));
        const cart_form = document.querySelector('.t4s-btn__checkout');
        if ((decodedCwToken?.shopify_customer_id == customerId) && (cart_form.classList.contains('has_digital'))) {
          // if (checkout_btn) {
          //   checkout_btn.style.display = 'none';
          // }
       /** ****************************ClassWallet - Updated End**********************************/

          if (error_msg) {
            error_msg.style.display = 'block';
          }
        } else {
          if (checkout_btn) {
            checkout_btn.style.display = 'block';
          }

          if (error_msg) {
            error_msg.style.display = 'none';
          }
        }
      } else {
        if (checkout_btn) {
          checkout_btn.style.display = 'block';
        }

        if (error_msg) {
          error_msg.style.display = 'none';
        }
      }
    }

    check_classwallet();

    $('body').on('click', '.t4s-page_cart__item button.t4s-quantity-selector,.t4s-page_cart__item .t4s-page_cart__remove', function(e) {
      setTimeout(function() {
        fetch(window.location.href, {
          method: "GET",
          headers: {
            'Content-Type': 'text/html'
          }
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          return response.text();
        })
        .then(htmlContent => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(htmlContent, "text/html");
          let cartDrawerElement = doc.querySelector(".t4s-btn-group__checkout-update");

          if (cartDrawerElement) {
            let targetElement = document.querySelector(".t4s-btn-group__checkout-update");
            if (targetElement) {
              targetElement.outerHTML = cartDrawerElement.outerHTML;
            }
          }
          check_classwallet()
        });
      }, 2000);
    });
  }
});
$(document).on('click','.t4s-drawer__close',function(e){
  $('.t4s-filter-hidden').attr('aria-hidden','true');
  $('.t4s-close-overlay').removeClass('is--visible');
  $('body').removeClass('t4s-lock-scroll is--opend-drawer');
})
$(document).on('click','.t4s-facets__form .t4s-filter__values li',function(e){
  $(this).parents('.t4s-filter-hidden').attr('aria-hidden','false');
  $('.t4s-close-overlay').addClass('is--visible');
  $('body').addClass('t4s-lock-scroll is--opend-drawer');
})
//jump link to new window
function openInNewWindow(targetUrl) {
  window.open(targetUrl, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes");
}

document.addEventListener("click", function (e) {
  const link = e.target.closest('a[href="#giveaway"]');
  if (!link) return;

  e.preventDefault();

  const target = document.querySelector(".infoleft-block-left-container");
  if (!target) return;

  const offset = 90; // mobile header height
  const y =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    offset;

  window.scrollTo({ top: y, behavior: "smooth" });
});
